export default __webpack_public_path__ + "static/icon-data-e0eee5240c335934aba7e5e981ca74ae.svg";